<svg width="281" height="11" viewBox="0 0 281 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1H281" stroke="#DDDAD2" />
    <path d="M140.5 9.5L132.5 1.5H148.5L140.5 9.5Z" stroke="#DDDAD2" />
    <path d="M140.5 8.5L132.5 0.5H148.5L140.5 8.5Z" fill="#F6F2E9" />
</svg>